import React from 'react'
import css from './index.module.css'
import { ReactComponent as LogoIcon } from '../assets/logo.svg';

const Logo = () => {
  return (
    <div className={css.component_logo}>
        <LogoIcon />
    </div>

  )
}

export default Logo
